<template>
  <div class="btn-download-mobile" @click="download()">
    <button class="btn-download-mobile--button">
      <span class="btn-download-mobile--button--icon"
        ><svgicon :name="'download'" height="1rem" width="1rem" />
      </span>
    </button>
    <p class="btn-download-mobile--text">{{ content.text }}</p>
  </div>
</template>

<script>
export default {
  name: "BtnDownloadMobile",
  computed: {
    content() {
      return this.$t("landing").downloadBtn;
    },
  },
  methods: {
    download() {
      const pdf = this.content.href;
      window.open(pdf, "_blank").focus();

      window.digitalData.push({
        event: "click-download",
        pageEvent: {
          eventInfo: {
            eventDetail: "PDF",
            contentTitle: this.content.title,
            contentWidget: "wer",
            contentURL: pdf,
            ctaLabel: this.content.text,
          },
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.btn-download-mobile {
  position: fixed;
  left: 50%;
  bottom: toRem(16);
  transform: translate(-50%, 0);
  max-width: none;
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 2;

  &--button {
    border-radius: toRem(40);
    max-width: toRem(32);
    height: toRem(32);
    background-color: $primary-yellow;
    &--icon {
      padding: toRem(8);
    }
  }
  
  &--text {
    margin-top: toRem(12);
    white-space: nowrap;
    text-transform: uppercase;
    color: $white-08;
    @include link-M;
  }
}
</style>
